import type { BetterDocInsurance } from "@/modules/patients/detail/better-doc/types"
import { Insurees } from "@/modules/patients/services/usePatientByIdQuery"
import { BetterDoc } from "@/types/__generated__/union-types"

const validBetterDocConfigurations: BetterDoc[] = ["ALLOWED", "REQUIRED", "CONDITION_PACKAGE"]

export const getBetterDocInsurance = (insurees: Insurees): BetterDocInsurance | null => {
  for (const insuree of insurees) {
    if (!insuree.insureeNumber) continue

    for (const coverage of insuree.activeCoverages) {
      const { productConfiguration } = coverage.product
      if (productConfiguration && validBetterDocConfigurations.includes(productConfiguration.betterDoc)) {
        return {
          insureeNumber: insuree.insureeNumber,
          productKey: productConfiguration.betterDocKey,
          organizationName: insuree.organisation.name,
        }
      }
    }
  }
  return null
}
